<template>
  <nav class="app-breadcrumbs" aria-label="Навигация">
    <ol class="app-breadcrumbs-list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="app-breadcrumbs-item"
      >
        <span v-if="index > 0" class="app-breadcrumbs-sep" aria-hidden="true">›</span>
        <router-link v-if="item.to" :to="item.to" class="app-breadcrumbs-link">
          {{ item.label }}
        </router-link>
        <span v-else class="app-breadcrumbs-current" aria-current="page">
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>
